import { Text } from '@wartek-id/text-v1'

import TahapanItem from './TahapanItem'

import type { MultiPeriodParams } from 'types/kinerja'
import type {
  TFollowUpEvaluationDocumentStates,
  TPelaksanaanAppealableStep,
  TStatePelaksanaan,
} from 'types/kinerja-pelaksanaan'
import type { TahapanPelaksanaanType } from '../../constants/tahapanPelaksanaan'

type TahapanPelaksanaanItemsProps = {
  progressPercentage: number
  state?: TStatePelaksanaan
  latestFormState?: TFollowUpEvaluationDocumentStates
  appealState?: TPelaksanaanAppealableStep
  tahapanPelaksanaanConstant: TahapanPelaksanaanType
  ptkId?: string
  periodParams?: MultiPeriodParams
}

const TahapanPelaksanaanItems = ({
  progressPercentage,
  tahapanPelaksanaanConstant,
  latestFormState,
  appealState,
  state,
  ptkId,
  periodParams,
}: TahapanPelaksanaanItemsProps) => {
  const Tahap1Item = tahapanPelaksanaanConstant.bagian1.map(
    (tahapan, index, tahapanPelaksanaan) => (
      <TahapanItem
        tahapan={tahapan}
        index={index}
        state={state}
        latestFormState={latestFormState}
        appealState={appealState}
        tahapanPelaksanaanLength={tahapanPelaksanaan.length}
        progressPercentage={progressPercentage}
        key={index}
        ptkId={ptkId}
        periodParams={periodParams}
      />
    )
  )
  const Tahap2Item = tahapanPelaksanaanConstant.bagian2.map(
    (tahapan, index, tahapanPelaksanaan) => (
      <TahapanItem
        tahapan={tahapan}
        index={index}
        state={state}
        latestFormState={latestFormState}
        appealState={appealState}
        tahapanPelaksanaanLength={tahapanPelaksanaan.length}
        progressPercentage={progressPercentage}
        key={index}
        ptkId={ptkId}
        periodParams={periodParams}
      />
    )
  )
  return (
    <>
      <Text variant="heading-sm" className="pt-6 pb-2">
        Bagian 1: Pelaksanaan Observasi
      </Text>
      <div className="flex gap-2 items-center">{Tahap1Item}</div>
      <Text variant="heading-sm" className="pt-6 pb-2">
        Bagian 2: Pelaksanaan Tindak Lanjut
      </Text>
      <div className="flex gap-2 items-center">{Tahap2Item}</div>
    </>
  )
}

export default TahapanPelaksanaanItems
